import { useSelector } from 'react-redux';

import { BuildingDetails } from './BuildingDetails';
import { selectBuildingCard } from 'shared/selectors/buildingCard';
import { getDetailsProps } from 'shared/utils/buildingDetails';

export const BuildingDetailsContainer = () => {
  const card = useSelector(selectBuildingCard);

  return <BuildingDetails props={getDetailsProps(card)} />;
};
